import { env } from '@/config/env';
import type { OrganizationPlanId, OrganizationType } from '@/lib/db/schema';

export const ENTERPRISE_REQUIRED_ERROR_CODE = 'ENTERPRISE_REQUIRED';
const ENTERPRISE_CONTACT_FALLBACK_URL =
  'https://calendly.com/aria-arkyv/enterprise';
const SUPPORT_CONTACT_URL = 'mailto:support@arkyv.ai';

export function canOrganizationUseMultiUserFeatures(
  organizationType: OrganizationType | null | undefined,
  organizationPlanId?: OrganizationPlanId | null | undefined,
): boolean {
  if (isSingleUserPlan(organizationPlanId)) {
    return false;
  }

  if (organizationPlanId === 'pro') return true;

  return organizationType === 'enterprise' || organizationType === 'team';
}

export function isSingleUserOrganization(
  organizationType: OrganizationType | null | undefined,
  organizationPlanId?: OrganizationPlanId | null | undefined,
): boolean {
  return !canOrganizationUseMultiUserFeatures(
    organizationType,
    organizationPlanId,
  );
}

export function getEnterpriseContactUrl(): string {
  return (
    env.NEXT_PUBLIC_ENTERPRISE_CONTACT_URL || ENTERPRISE_CONTACT_FALLBACK_URL
  );
}

export function getSupportContactUrl(): string {
  return SUPPORT_CONTACT_URL;
}

export function getEnterpriseRequiredMessage(): string {
  return 'Multi-user access requires Pro. Upgrade to invite collaborators.';
}

export function getEnterpriseRequiredErrorPayload() {
  return {
    errorCode: ENTERPRISE_REQUIRED_ERROR_CODE,
    error: getEnterpriseRequiredMessage(),
    contactUrl: getEnterpriseContactUrl(),
  };
}

export function canOrganizationBookSupportMeeting(
  planId: OrganizationPlanId | null | undefined,
): boolean {
  return planId === 'enterprise';
}

export function isSingleUserPlan(
  planId: OrganizationPlanId | null | undefined,
): boolean {
  return planId === 'free';
}
